module.exports = __webpack_public_path__ + "img/public/AdminIcons/dashBoardUserIcon.svg?1ea833ec";